import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { useAuth } from '@pray/shared/hooks/useAuth';

import IndexPage from 'components/pages/IndexPage/IndexPage';
import { useStudioContext } from 'context/StudioContext';
import useAppRoutes from 'hooks/useAppRoutes';
import { readTicketLoginReturnTo } from 'utils/ticketLoginReturnTo';

export default function Index() {
  const appRoutes = useAppRoutes();
  const { search } = useLocation();
  const navigate = useNavigate();
  const { user } = useAuth();
  const { selectedArtist } = useStudioContext();

  const isUserRegistered = !!user?.is_registered;
  const isUserPermissionsResolved = !!user?.is_permissions_resolved;
  const isUserResolved = isUserRegistered && isUserPermissionsResolved;
  const isArtistResolved = selectedArtist?.isResolved;
  const ticketReturnTo = readTicketLoginReturnTo(search);

  useEffect(() => {
    // The /tickets route checks Ticketing access itself, so every signed-in user returns to their link.
    if (isUserResolved && ticketReturnTo) {
      navigate(ticketReturnTo, { replace: true });
      return;
    }
    if (isUserResolved && isArtistResolved && selectedArtist.id) {
      navigate(appRoutes.initial(), { replace: true });
    } else if (isUserResolved && isArtistResolved) {
      navigate(appRoutes.getStarted(), { replace: true });
    }
  }, [isUserResolved, isArtistResolved, selectedArtist.id, ticketReturnTo]);

  // if user is registered return null
  if (isUserRegistered) {
    return null;
  }

  // if user is not registered show index page
  return <IndexPage />;
}
